import SelectComponent from "formiojs/components/select/Select";
import Formio from "formiojs/Formio";
import { environment } from "../../../environments/environment";

export class SelectWithAddCustomClassComponent extends SelectComponent {

  private choices: any;
  private treeselect: any;
  private currentItems: [];
  private selectOptionValues: any[];
  private options: any;
  private requestHeaders: any;
  private loadItems: any;
  private dataValue: any;
  private triggerUpdate: any;
  private baseUrl: string = environment.BASE_URL;
  private addButtonElement: HTMLButtonElement;
  private t: any;
  private component: any;

  static get builderInfo() {
    return {
      title: "catalogue",
      group: "basic2", // different group name to remove from toolbar
      icon: "fas fa-server",
      weight: 70,
      documentation: "http://help.form.io/userguide/#select",
      schema: SelectComponent.schema(),
    };
  }

  private registerInputForCreatingOption(input: HTMLInputElement, target: Element, end: boolean) {
    if (!input || !target) {
      return;
    }
    this.addButtonElement = null;
    input.addEventListener("input", (ev) => {
      if (input.value.trim().length < 4 || this.selectOptionValues && this.selectOptionValues.includes(input.value)) {
        if (this.addButtonElement?.parentNode) {
          this.addButtonElement.remove();
        }
        return;
      }
      if (!this.addButtonElement) {
        this.addButtonElement = document.createElement("button", {});
        this.addButtonElement.classList.add("btn");
        this.addButtonElement.appendChild(document.createTextNode(this.t("Add Custom Class")));
        this.addButtonElement.addEventListener("click", () => {
          const value = input.value.trim();
          this.requestHeaders.then((headers) => {
            Formio.makeRequest(this.options.formio, "select", this.baseUrl + "styles/custom_class", "POST", value, { header: headers }).then(() => {
              input.value = "";
              let dataValue = this.dataValue;
              if (!dataValue) {
                dataValue = [];
              }
              if (Array.isArray(dataValue)) {
                dataValue.push(value);
              } else {
                dataValue = value;
              }
              this.setValue(dataValue);
              this.triggerUpdate();
            });
          });
        });
      }
      if (!this.addButtonElement.parentNode) {
        if (end) {
          target.appendChild(this.addButtonElement);
        } else {
          target.prepend(this.addButtonElement);
        }
      }
    });
  }

  public addInput(input: any, container: any) {
    super.addInput(input, container);
    if (this.choices && this.choices.passedElement && this.choices.passedElement.element) {
      this.choices.passedElement.element.addEventListener("addItem", (event) => {
        if (this.choices.input && this.choices.input.element) {
          this.choices.input.element.value = "";
          this.choices.input.element.dispatchEvent(new Event("input", { bubbles: true }));
        }
      });
    }
    if (!this.component.creatable) {
      return;
    }
    if (this.choices && this.choices.input && this.choices.input.element) {
      this.registerInputForCreatingOption(this.choices.input.element, this.choices.input.element.parentNode, true);
    } else if (this.treeselect?.srcElement) {
      const treeSelectMount = this.treeselect.mount.bind(this.treeselect);
      this.treeselect.mount = () => {
        treeSelectMount();
        this.registerTreeSelectForCreating();
      };
      this.registerTreeSelectForCreating();
      // Listen for value changes in TreeSelect
      this.treeselect.srcElement.addEventListener("input", (e) => {
        const val = this.treeselect.value;
        // If a value is selected, clear the input
        // Note: TreeSelect might not expose a simple 'addItem' event like Choices, so we rely on setValue or input check
      });
    }
  }

  private registerTreeSelectForCreating() {
    const operatorsElement = this.treeselect.srcElement.querySelector(".treeselect-input__operators");
    const inputElement = this.treeselect.srcElement.querySelector(".treeselect-input__edit");
    if (inputElement) {
      inputElement.addEventListener("blur", () => {
        inputElement.value = "";
        inputElement.dispatchEvent(new Event("input", { bubbles: true }));
      });
    }
    this.registerInputForCreatingOption(inputElement, operatorsElement, false);
  }

  public onChange(flags: any, fromRoot: boolean) {
    if (this.treeselect && this.treeselect.srcElement) {
      const inputElement = this.treeselect.srcElement.querySelector(".treeselect-input__edit");
      if (inputElement) {
        inputElement.value = "";
        inputElement.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
    super.onChange(flags, fromRoot);
  }

  public setValue(value, flags?) {
    if (this.treeselect && this.treeselect.srcElement) {
      setTimeout(() => {
        const inputElement = this.treeselect.srcElement.querySelector(".treeselect-input__edit");
        if (inputElement) {
          inputElement.value = "";
          inputElement.dispatchEvent(new Event("input", { bubbles: true }));
        }
      }, 0);
    }
    if (this.addButtonElement?.parentNode) {
      this.addButtonElement.remove();
    }
    return super.setValue(value, flags);
  }
}
